export default __webpack_public_path__ + "static/media/o.839db302.png";